// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__za3vD","note":"Settings_note__+ROt7","content":"Settings_content__56kv+"};